/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { ShipExpectedCustomers } from './ShipExpectedCustomers';
import {
    ShipExpectedCustomersFromJSON,
    ShipExpectedCustomersFromJSONTyped,
    ShipExpectedCustomersToJSON,
    ShipExpectedCustomersToJSONTyped,
} from './ShipExpectedCustomers';

/**
 * 
 * @export
 * @interface ResponseShipExpectedCustomer
 */
export interface ResponseShipExpectedCustomer {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseShipExpectedCustomer
     */
    result: ResponseResult;
    /**
     * 
     * @type {ShipExpectedCustomers}
     * @memberof ResponseShipExpectedCustomer
     */
    data: ShipExpectedCustomers;
}

/**
 * Check if a given object implements the ResponseShipExpectedCustomer interface.
 */
export function instanceOfResponseShipExpectedCustomer(value: object): value is ResponseShipExpectedCustomer {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseShipExpectedCustomerFromJSON(json: any): ResponseShipExpectedCustomer {
    return ResponseShipExpectedCustomerFromJSONTyped(json, false);
}

export function ResponseShipExpectedCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseShipExpectedCustomer {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': ShipExpectedCustomersFromJSON(json['data']),
    };
}

export function ResponseShipExpectedCustomerToJSON(json: any): ResponseShipExpectedCustomer {
    return ResponseShipExpectedCustomerToJSONTyped(json, false);
}

export function ResponseShipExpectedCustomerToJSONTyped(value?: ResponseShipExpectedCustomer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': ShipExpectedCustomersToJSON(value['data']),
    };
}

